/* import __COLOCATED_TEMPLATE__ from './boot-error.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

const BootError = templateOnlyComponent();
export default BootError;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BootError: typeof BootError;
    'boot-error': typeof BootError;
  }
}
